<template>
  <LineChartGenerator
    :chart-options="chartOptions"
    :chart-data="chartData"
    :chart-id="chartId"
    :dataset-id-key="datasetIdKey"
    :plugins="plugins"
    :css-classes="cssClasses"
    :styles="styles"
    :width="width"
    :height="height"
  />
</template>

<script>
import { Line as LineChartGenerator } from 'vue-chartjs/legacy'

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement
} from 'chart.js'

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement
)

export default {
  name: 'LineChart',
  components: {
    LineChartGenerator
  },
  props: {
    chartId: {
      type: String,
      default: 'line-chart'
    },
    datasetIdKey: {
      type: String,
      default: 'label'
    },
    width: {
      type: Number,
      default: 400
    },
    height: {
      type: Number,
      default: 200
    },
    cssClasses: {
      default: '',
      type: String
    },
    styles: {
      type: Object,
      default: () => {}
    },
    plugins: {
      type: Array,
      default: () => []
    },
    theChartData: {
      required: true
    }
  },
  data() {
    return {
      chartData: {
        labels: this.theChartData.labels,
        datasets: [
          {
            label: 'Active Player',
            type: "bar",
            data: this.theChartData.active_monthly_statisitcs,
            hidden: false,
            backgroundColor: "rgba(224,247,250,.3)",
            pointBackgroundColor: "#FFFFFF",
            borderColor: "#4DD0E1",
            borderWidth: 1,
            borderRadius: 3,
            borderSkipped: false,  
            fill: true
          },
        ]
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        lineTension: .3,
        plugins: {
          datalabels: {
            display: false,
          }
        }
      }
    }
  },
}
</script>
